import { DirectionEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { isAfter } from "date-fns";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

const useTripDetailsEffect = () => {
    const bookingStore = useBookingStore();

    const outwardDate = computed(() => {
        return bookingStore.getDate(DirectionEnum.Outward);
    });

    const returnDate = computed(() => {
        return bookingStore.getDate(DirectionEnum.Return);
    })

    const tripDetailsProperties = computed(() => {
        const modeOfTravel = bookingStore.getBooking.modeOfTravel;
        const routes = [DirectionEnum.Outward, DirectionEnum.Return].map(d => bookingStore.getRoute(d));

        return [modeOfTravel, routes];
    });

    const clearDepartures = () => {
        [DirectionEnum.Outward, DirectionEnum.Return].map(d => bookingStore.clearDeparture(d));
    }

    const unsubscribe = ref<any[]>([]);
    onMounted(() => {
        unsubscribe.value.push(watch(tripDetailsProperties, () => {
            clearDepartures();
        }));

        unsubscribe.value.push(watch(outwardDate, () => {
            bookingStore.clearDeparture(DirectionEnum.Outward);

            if(outwardDate.value && returnDate.value) {
                if(isAfter(new Date(outwardDate.value), new Date(returnDate.value))) {
                    bookingStore.clearDeparture(DirectionEnum.Return);                
                }
            }        
        }));

        unsubscribe.value.push(watch(returnDate, () => {
            bookingStore.clearDeparture(DirectionEnum.Return);
        }));
    });

    onBeforeUnmount(() => {
        unsubscribe.value.forEach(v => v());
    })
}

export default useTripDetailsEffect;